// Angular
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { User, currentUser, isLoggedIn } from '@app/core/auth';
import { Store, select } from '@ngrx/store';
import { AppState } from '@app/core/reducers';
import { CartProductService } from '@app/api/api';
import { environment } from 'environments/environment';
@Component({
  selector: 'kt-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss'],
})
export class CartComponent implements OnInit, AfterViewInit {
  listProductCart: any = [];
  user$: Observable<User>;
  enviroment: any = environment;
  total: number;
  // Public properties

  // Set icon class name
  @Input() icon = 'flaticon2-shopping-cart-1';
  @Input() iconType: '' | 'brand';

  // Set true to icon as SVG or false as icon class
  @Input() useSVG: boolean;

  // Set bg image path
  @Input() bgImage: string;

  /**
   * Component constructor
   */
  constructor(private store: Store<AppState>, private cartProductService: CartProductService) {}
  isShow: boolean = false;
  /**
   * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
   */

  /**
   * After view init
   */
  ngAfterViewInit(): void {}

  /**
   * On init
   */
  getAllProductInCart() {
    this.cartProductService.apiMyCartProductsGet().subscribe((res) => {
      if (res.success == true) {
        this.listProductCart = res.data.collection.map((item) => {
          return {
            name: item.extend_product.name,
            image: this.enviroment.backendhost + item.extend_product.default_image,
            quantity: item.quantity,
            price: item.extend_product.price,
          };
        });
        this.total = this.listProductCart.reduce((preve, next) => {
          return preve + next.price * next.quantity;
        }, 0);
      }
    });
  }

  ngOnInit(): void {
    // isLoggedIn — ngay lập tức khi Login dispatch
    this.store.pipe(select(isLoggedIn)).subscribe(loggedIn => {
      if (loggedIn) {
        this.isShow = true;
      } else {
        const token = localStorage.getItem(this.enviroment.authTokenKey);
        this.isShow = !!(token && token.length > 10);
      }
    });

    this.user$ = this.store.pipe(select(currentUser));
    this.user$.subscribe((res) => {
      if (res) {
        this.isShow = true;
      }
    });
    this.cartProductService.apiMyCartProductsGet().subscribe((reslst) => {
      if (reslst.success) {
        if (reslst.data.collection.length == 0) {
          $('.numberOfProduct').text('');
        } else {
          $('.numberOfProduct').text(reslst.data.collection.length);
        }
      }
    });

    this.getAllProductInCart();
  }
}
